<template>
<div class="order-wrapper dispatch-content">
  <div class="loading-app" v-if="loading">
    <Spinner />
  </div>
  <pre>
</pre>
  <Header
   v-if="!loading"
   :loading="loading"
   :dispatch="dispatch"
  :total_ton ="sumWeigth()" />
  <List
  v-if="!loading"
  :dispatch="dispatch"
  :generateOtp="generateOtp"
  v-on:otpSubmit="otpSubmit"
  v-on:pod="pod" />
  <!-- <Footer
  v-if="!loading"
  :dispatch="dispatch"/> -->
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '../../dispatch/Header';
import List from '../../dispatch/List';
import Footer from '../../dispatch/Footer';

export default {
  components: {
    Header,
    List,
    Footer,
  },
  computed: {
    ...mapGetters({
      dispatch: 'pod/consigneeTrack',
      loading: 'pod/isLoading', // checking data loaded or not via getters
    }),
  },
  created() {
    this.getOrderDetails();
  },
  data() {
    return {
      generateOtp: false,
    };
  },
  methods: {
    async otpSubmit(data) {
      if (data === '') {
        this.$error({
          message: 'Please enter OTP',
        });
      } else {
        const params = { id: this.$route.params.orderId, trackId: this.$route.params.trackId };
        try {
          const result = await this.$store.dispatch('pod/submitOtp', { params, data: { otp_number: data } });
          if (result.status === 401) {
            this.$error({
              message: 'Invalid OTP',
            });
          }
          if (result.vehicle) {
            this.$success({
              message: 'POD submitted.',
            });
          }
        } catch (error) {
          this.$error({
            message: 'Unable to Process',
          });
        }
      }
    },
    async pod() {
      const hasConfirm = await this.$PromptConfirm('Are you sure wants to submit POD', 'Confirmation', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        lockScroll: true,
        showClose: false,
        center: true,
        dangerouslyUseHTMLString: true,
      });
      if (hasConfirm === 'confirm') {
        this.epodSubmit();
      }
    },
    async epodSubmit() {
      const data = {};
      data.id = this.dispatch.id;
      const materials = this.dispatch.materials.map(material => ({
        id: material.id,
        leakage_count: material.leakage_count,
        damage_count: material.damage_count,
        hold_count: material.hold_count,
        excess_count: material.excess_count,
        shortage_count: material.shortage_count,
        carton_damage_count: material.carton_damage_count,
        comment: (material.shortage_count !== 0 || material.damage_count !== 0 || material.leakage_count) ? material.comment : '',
      }));
      try {
        const params = { id: this.$route.params.orderId, trackId: this.$route.params.trackId };

        const result = await this.$store.dispatch('pod/markAsDelivered', { params, data: materials });
        if (result.order_number) {
          this.$success({
            message: 'Please Enter OTP',
          });

          this.generateOtp = true;
          // this.$router.push({ name: 'Login' });
        } else {
          this.$error({
            message: 'Please try again, POD not updated!',
          });
        }
      } catch (error) {
        // log
      }
    },
    async getOrderDetails() {
      const params = { id: this.$route.params.orderId, trackId: this.$route.params.trackId };
      return this.$store.dispatch('pod/track', params).then(() => {
        if (!this.dispatch.id) {
          this.$PromptConfirm('POD links does not exist', 'Invalid Link', {
            confirmButtonText: 'Redirect to Home',
            showCancelButton: false,
            lockScroll: true,
            showClose: false,
            center: true,
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'Login' });
          }).catch(() => {
            this.$router.push({ name: 'Login' });
          });
        }
      });
    },
    sumWeigth() {
      let totoalWeight = 0;
      let totoalQty = 0;
      if (this.dispatch && this.dispatch.materials) {
        this.dispatch.materials.forEach((item) => {
          totoalWeight += item.weight.value;
          totoalQty += item.quantity.value;
        });
      }
      return `${totoalWeight.toFixed(2)} / ${totoalQty}`;
    },
  },
};
</script>
